import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { LayoutState, ShowRightSideSplitter } from '../../store';
import { getSelectedTab, selectIsHeaderVisible } from '../../store/selectors/layout.selector';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/core/services/layout.service';


@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss']
})
export class CanvasComponent implements OnInit {

  isLeftOpened = false;
  isRightOpened = false;
  isTopOpened = false;
  isBottomOpened = false;
  isRightPaneVisible = false;
  isHeaderVisible= true;
  isBusyLoader: boolean;

  constructor(private store: Store<LayoutState>, private router: Router, private layoutService: LayoutService) { }

  ngOnInit() {
    this.layoutService.busyLoader.subscribe(value => {
      setTimeout(() => {
      this.isBusyLoader = value;
    },10);
    });
    this.store.pipe(select(getSelectedTab)).subscribe(res => {
      if (res.selectedTile) {
        this.isRightPaneVisible = res.selectedTile.isRightPanelVisible;
        this.isRightOpened = res.selectedTile.isRightPanelOpenByDefault;
        this.isRightOpened = res.isRightPanelOpen;
        this.router.navigate([res.selectedTile.route]);
      }
    });


    this.store.pipe(select(selectIsHeaderVisible)).subscribe(res => {
   
        this.isHeaderVisible = res;
     
    });
  }

}
